import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import InputBooleanBase, {
  INPUT_BOOLEAN_VARIANTS
} from '../internals/InputBooleanBase';
import InputBoolean from '../internals/InputBoolean';
import InputBooleanGroup, {
  variantPropTypeValidation
} from '../internals/InputBooleanGroup';

const CheckboxGroup = ({
  inline,
  items,
  onBlur,
  onChange,
  values,
  variant,
  ...otherProps
}) => {
  const [checkboxesSelected, setCheckboxesSelected] = useState(values);

  /* In case values has been updated outside this function,
    it'll refresh checkboxesSelected
  */
  useEffect(() => {
    setCheckboxesSelected(values);
  }, [values]);

  const handleChange = checkboxValue => event => {
    const nextList = checkboxesSelected.includes(checkboxValue)
      ? checkboxesSelected.filter(cx => cx !== checkboxValue)
      : [...checkboxesSelected, checkboxValue];

    setCheckboxesSelected(nextList);
    if (onChange) onChange(nextList, event);
  };

  const handleOnBlur = event => {
    if (onBlur) onBlur(checkboxesSelected, event);
  };

  return (
    <InputBooleanGroup
      {...otherProps}
      type='checkbox'
      onBlur={handleOnBlur}
      variant={inline ? variant : INPUT_BOOLEAN_VARIANTS.regular}
      items={items}
      renderItems={({ itemValue, itemId, ...itemProps }) => (
        <InputBooleanBase
          {...itemProps}
          key={itemId}
          id={itemId}
          value={itemValue}
          onChange={handleChange(itemValue)}
          checked={checkboxesSelected.includes(itemValue)}
        />
      )}
    />
  );
};

CheckboxGroup.defaultProps = {
  inline: false,
  values: []
};

CheckboxGroup.propTypes = {
  inline: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      ...InputBoolean.propTypes,
      label: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  variant: variantPropTypeValidation
};

export default CheckboxGroup;
